import { defineComponent as _defineComponent } from 'vue'
import { useUser } from '../../composables/useUser';
import AoRecruitingDashboard from '../../modules/AoRecruitingDashboard/views/AoRecruitingDashboard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AORecruitingDashboard',
  setup(__props) {

const user = useUser()

return { __sfc: true,user, AoRecruitingDashboard }
}

})